exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-26da9d58]{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;font-weight:600}.avatar-circle[data-v-26da9d58]{border-radius:50%}.avatar-soft-primary[data-v-26da9d58]{background-color:rgba(55,125,255,.1);color:#377dff}.table-progress[data-v-26da9d58]{height:.5rem;width:100%;border-radius:1rem}.bg-soft-success[data-v-26da9d58]{background-color:rgba(0,201,167,.1)!important}.bg-soft-danger[data-v-26da9d58]{background-color:rgba(237,76,120,.1)!important}.bg-soft-secondary[data-v-26da9d58]{background-color:rgba(113,119,125,.1)!important}", ""]);

// exports
